import { useLocale } from "@/i18n/context";

/**
 * Keyboard/screen-reader affordance: a visually hidden link that becomes
 * visible on focus and jumps past the header to the page's main content.
 * Target element must have id="main-content" and tabIndex={-1}.
 */
export function SkipToContent() {
  const { t } = useLocale();

  return (
    <a
      href="#main-content"
      className="sr-only rounded-md bg-background px-4 py-2 text-sm font-medium text-foreground shadow-lg outline-none ring-2 ring-primary focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[200]"
    >
      {t.common.skipToContent}
    </a>
  );
}
